var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElementEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/element-equal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 16.4846H15C14.59 16.4846 14.25 16.1446 14.25 15.7346C14.25 15.3246 14.59 14.9846 15 14.9846H21C21.41 14.9846 21.75 15.3246 21.75 15.7346C21.75 16.1446 21.41 16.4846 21 16.4846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21 20.4846H15C14.59 20.4846 14.25 20.1446 14.25 19.7346C14.25 19.3246 14.59 18.9846 15 18.9846H21C21.41 18.9846 21.75 19.3246 21.75 19.7346C21.75 20.1446 21.41 20.4846 21 20.4846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M22 8.75462V4.21462C22 2.80462 21.36 2.23462 19.77 2.23462H15.73C14.14 2.23462 13.5 2.80462 13.5 4.21462V8.74462C13.5 10.1646 14.14 10.7246 15.73 10.7246H19.77C21.36 10.7346 22 10.1646 22 8.75462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.5 8.75462V4.21462C10.5 2.80462 9.86 2.23462 8.27 2.23462H4.23C2.64 2.23462 2 2.80462 2 4.21462V8.74462C2 10.1646 2.64 10.7246 4.23 10.7246H8.27C9.86 10.7346 10.5 10.1646 10.5 8.75462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.4,
    d: "M10.5 20.0046V15.9646C10.5 14.3746 9.86 13.7346 8.27 13.7346H4.23C2.64 13.7346 2 14.3746 2 15.9646V20.0046C2 21.5946 2.64 22.2346 4.23 22.2346H8.27C9.86 22.2346 10.5 21.5946 10.5 20.0046Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementEqual);
export default __webpack_public_path__ + "static/media/element-equal.d9e79197d92320a75f40eba208168682.svg";
export { ForwardRef as ReactComponent };